import React from "react";
import { FormProvider, UseFormReturn } from "react-hook-form";

interface FormProviderWrapperProps {
  methods: UseFormReturn<any>;
  onSubmit: (data: any) => void;
  children: React.ReactNode;
  className?: string;
}

export const FormProviderWrapper: React.FC<FormProviderWrapperProps> = ({
  methods,
  onSubmit,
  children,
  className = "",
}) => {
  return (
    <FormProvider {...methods}>
      <form
        className={className}
        onSubmit={methods.handleSubmit((data, event) => {
          event?.preventDefault();
          onSubmit(data);
        })}
      >
        {children}
      </form>
    </FormProvider>
  );
};
